export default function PHP_connect_errno() {
  return (
    <div>
      <h1>PHP_connect_errno</h1>
    </div>
  );
}
